import { Radio, Typography } from "antd";
import dayjs from "dayjs";
import { useState } from "react";

const { Text } = Typography;

const AbsoluteRelativeDatePicker = ({ onChange }) => {
    const [dateValue, setDateValue] = useState(null);
    const onDateValueChange = (e) => {
        setDateValue(e.target.value);
        const [itemValue, itemType] = e.target.value.split("_");
        onChange && onChange(dayjs().add(parseInt(itemValue), itemType));
    };
    return (
        <div className="grid grid-cols-[max-content_1fr] items-center gap-4">
            <Text strong>Minutes</Text>
            <Radio.Group onChange={onDateValueChange} value={dateValue}>
                <Radio.Button value="5_minutes">5</Radio.Button>
                <Radio.Button value="10_minutes">10</Radio.Button>
                <Radio.Button value="15_minutes">15</Radio.Button>
                <Radio.Button value="20_minutes">20</Radio.Button>
                <Radio.Button value="30_minutes">30</Radio.Button>
            </Radio.Group>
            <Text strong>Hours</Text>
            <Radio.Group onChange={onDateValueChange} value={dateValue}>
                <Radio.Button value="1_hours">1</Radio.Button>
                <Radio.Button value="2_hours">2</Radio.Button>
                <Radio.Button value="3_hours">3</Radio.Button>
                <Radio.Button value="6_hours">6</Radio.Button>
                <Radio.Button value="8_hours">8</Radio.Button>
                <Radio.Button value="12_hours">12</Radio.Button>
            </Radio.Group>
            <Text strong>Days</Text>
            <Radio.Group onChange={onDateValueChange} value={dateValue}>
                <Radio.Button value="1_days">1</Radio.Button>
                <Radio.Button value="2_days">2</Radio.Button>
                <Radio.Button value="3_days">3</Radio.Button>
                <Radio.Button value="4_days">4</Radio.Button>
                <Radio.Button value="5_days">5</Radio.Button>
                <Radio.Button value="6_days">6</Radio.Button>
            </Radio.Group>
            <Text strong>Weeks</Text>
            <Radio.Group onChange={onDateValueChange} value={dateValue}>
                <Radio.Button value="1_weeks">1</Radio.Button>
                <Radio.Button value="2_weeks">2</Radio.Button>
                <Radio.Button value="3_weeks">3</Radio.Button>
                <Radio.Button value="4_weeks">4</Radio.Button>
            </Radio.Group>
        </div>
    );
};

export default AbsoluteRelativeDatePicker;
